import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SortService,ToolbarService, FilterService,EditSettingsModel,EditService , ReorderService, TreeGridComponent, ToolbarItems, Column, RowDDService } from '@syncfusion/ej2-angular-treegrid';
import { GridComponent, IEditCell, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';

import { ApiService } from 'src/app/_services/api.service';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { v4 as uuidv4 } from 'uuid';
import { GlobalService } from 'src/app/_services/global.service';
import { Query, DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import { AutoCompleteComponent } from '@syncfusion/ej2-angular-dropdowns';
import { forkJoin } from 'rxjs';



@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css'],
  providers: [RowDDService,FilterService, SortService,ToolbarService, ReorderService,EditService,MessageService],
  encapsulation: ViewEncapsulation.None,
})

export class OrganizationComponent implements OnInit {
  showDialogNodo:boolean=false;
  @ViewChild('gridusers') public gridusers?: GridComponent;
  public searchSettings?: Object;
  firsttime:boolean=true;
  usersRoleList:any[]=[];
  newUserSelect:string='seleziona';
  toolbarUsersRoleOptions?: string[];
  showDialogUsersRole:boolean=false;
  dropData = ['Normal', 'Low', 'High', 'Critical', 'Breaker'];
  crole:string='';
  confermaElimina1:boolean=false;
  confermaElimina2:boolean=false;

   toolbarOption?: string[];
   dataManagerUsers: DataManager;
   // set the count for displays the suggestion items.
   suggestionCount: number = 3;
   query: Query = new Query().select(['value','text']).requiresCount();
   // maps the remote data column to fields property
   remoteFields: Object = { value:'value',text:'text' };
   //set the placeholder to AutoComplete input
   remoteWaterMark: string = 'Ricerca...';
     // bind change event
  filtroAttivo='';
  editSettings: EditSettingsModel;
  orgList:any[]=[];
  cloneordList:any[]=[];
  showDialog:boolean=false;
  showDialogUser:boolean=false;
  currentNodeHeader:string='';
  currentNodeDialogHeader:string='';
  cid:any;
  name:string='';
  uplevel:boolean=false;
  currentNode:any={};
  currentNodeApps:any={};
  usersDeleted:any[]=[];
  selectedrecords:any[]=[];
  nodeType:any='';
  nodeisManagement:boolean=false;

  code:string='';
  areaList:any[]=[];
  sedeList:any[]=[];
  rolesList:any[]=[];
  qualificheList:any[]=[];
  fieldsQualifiche: Object = { text: 'label', value: 'value' };
  arkiWebrolesList:{ [key: string]: Object }[] =[];
  arkiWebrolesfields: Object; 
  rsaCdcList:any[]=[];
  nodeRole:any;

  nodeArea:any;
  nodeSede:any;
  nodeRsaCdc:any;
  
  nodeSedeLoadSub:boolean=false;
  nodeAreaLoadSub:boolean=false;
  lastModifiedUser:string='';
  lastModifiedDate:Date=null;

  nodeUsersDeptLoadSub:boolean=false;
  nodeRsaLoadSub:boolean=false;

  nodeTypeList:any[]=[
    {value:'GENERICO',label:'GENERICO'},
    {value:'SEDE',label:'SEDE'},
    {value:'AREA',label:'AREA'},
    {value:'REP',label:'REPARTO'},
    {value:'RSA',label:'RESIDENZA'},
  
  ];
  modelloStruttura:any;
  

  @ViewChild(TreeGridComponent, { static: false }) treegrid: TreeGridComponent;
  @ViewChild(AutoCompleteComponent, { static: false }) autocompleteUsers: AutoCompleteComponent;
  
  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private globalService: GlobalService
  ) {
    this.dataManagerUsers = new DataManager({
      url: this.globalService.endpoint+'organizationchart/userslist',
      adaptor: new UrlAdaptor ,
      crossDomain: true,
      headers: [{ 'Authorization': 'Bearer ' +  localStorage.getItem('login_token') }] 
  });
   }

  ngOnInit(): void {
    if(this.route.snapshot.paramMap.get('filtro')){
      this.filtroAttivo=this.route.snapshot.paramMap.get('filtro');
    }
    this. arkiWebrolesfields= { text: "ID_rOLE", value: "NOME_ROLE" };
    this.orgList=[
      {
        id:1,
        name:'Caricamento in corso...',
        childs:[]
      }
    ];
    let sedi=this.apiService.get('organizationchart/getcdc',{});
    let aree=this.apiService.get('organizationchart/getaree',{});
    let roles=this.apiService.get('organizationchart/getroles',{});
    let tree=this.apiService.get('organizationchart/gettree',{});
    let rsaCdc=this.apiService.get('organizationchart/getcdcperstrutture',{});
    let qualifiche=this.apiService.get('organizationchart/getqualifiche',{});
    this.toolbarOption = ['Search'];
    this.toolbarUsersRoleOptions= ['Search'];
    this.searchSettings = { hierarchyMode:  'Both' };
  
    forkJoin([ sedi,aree,tree,roles,rsaCdc,qualifiche]).subscribe(data => {
      this.sedeList=data[0].Result;
      this.areaList=data[1].Result;
      this.rsaCdcList=data[4].Result;
      
      this.qualificheList=[];
      this.qualificheList.push({
        value:0,
        label:'-',
      });
      data[5].Result.forEach((t)=>{
        this.qualificheList.push({
          value:t.id,
          label:t.qualifica,
        });
      });

      this.rolesList=[];
  
      data[3].Result.forEach((t)=>{
        this.rolesList.push({
          value:t.id,
          label:t.node,
          childs:t.childs
        });
      });


      data[2].Result.forEach((t)=>{
        this.orgList=JSON.parse(t.jsontree);
    
     
        if(this.filtroAttivo=='modello'){
          this.cloneordList=JSON.parse(t.jsontree);
       
          this.orgList[0].childs.forEach((n,ind)=>{
            if(n.name=='Modello organizzativo struttura'){
              this.modelloStruttura=n;
            }
          });
          this.orgList=[this.modelloStruttura];
        } else{
   
          this.orgList[0].childs.forEach((n,ind)=>{
            if(n.name=='Modello organizzativo struttura'){
              this.modelloStruttura=n;
              this.orgList[0].childs.splice(ind,1);
            }
          });
          this.orgList[0].childs.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
        }

        this.lastModifiedUser=t.created_by;
        this.lastModifiedDate=t.creation_date;
      
     
      });
   
  
    });

    this.editSettings ={ allowEditing: true, allowAdding: true, allowDeleting: true, mode:"Row", newRowPosition: 'Child'}; 

   

    //this.treegrid.dataSource=this.orgList;
  }
  
  
  expandNode(ind) { 
    var row = this.treegrid.getRowByIndex(ind); 
    var data = this.treegrid.getCurrentViewRecords()[ind]; 
    this.treegrid.expandRow((row as HTMLTableRowElement), data);  //Expand specific row  
  } 
  
  actionComplete(args): void {
    if(this.firsttime){
      this.treegrid.collapseAtLevel(0);  //Expand specific row  
      this.expandNode(0);
      this.firsttime=false;
    }
    
  }
  
  updateNode(node:any,newNode:any){
    if(node.id==this.cid){
      node.name=newNode.name;
      node.code=newNode.code;
      node.roles=newNode.roles;
      node.qualifica=newNode.qualifica;
      node.isManagement=newNode.isManagement;
      node.type=newNode.type;
      if(!node.childs){
        node.childs=[];
      }
   
      newNode.childs.forEach((f)=>{
        node.childs.push(f);
      });

    } else{
      if(node.childs){
        node.childs.forEach( (n,i,objN)=>{
          this.updateNode(objN[i],newNode);
        });
      }
    }
  }

  addChildNode(node:any,newNode:any,search:boolean=false){
   
    if(node.id==this.cid){
  
      if(!node.childs){
        node.childs=[];
      }
      node.childs.unshift(newNode);
      if(search){
        this.treegrid.search(node.name);
      }
    } else{
      if(node.childs){
        node.childs.forEach( (n,i,objN)=>{
          this.addChildNode(objN[i],newNode,search);
        });
      }
    }
   
  }
  
  
  editNode(data){

    this.showDialog=true;
    this.cid=data.id;
    this.currentNode=data;

    this.nodeAreaLoadSub=false;
    this.nodeRsaLoadSub=false;
    this.confermaElimina2=false;
    this.confermaElimina1=false;
    this.nodeSedeLoadSub=false;
    this.nodeUsersDeptLoadSub=false;
    this.uplevel=false;
    this.name=data.name;
    this.code=data.code;
    this.nodeRole=null; 
    if(data.roles){
      data.roles.forEach((d)=>{
        this.nodeRole=d.value;
      });
    }
   
    this.nodeisManagement=data.isManagement
    this.nodeType=data.type;
  }


  save(){
    let params:any;
    if(this.filtroAttivo=='modello'){
      this.cloneordList[0].childs.forEach((n,ind)=>{
        if(n.name=='Modello organizzativo struttura'){
          this.cloneordList[0].childs.splice(ind,1);
        }
      });
      this.cloneordList[0].childs.push(this.orgList[0]);
      params={
        jsontree:JSON.stringify( this.cloneordList ),
        user_id:this.globalService.loggedUser.id
      };
    } else{
      this.orgList[0].childs.push(this.modelloStruttura);
      params={
        jsontree:JSON.stringify( this.orgList ),
        user_id:this.globalService.loggedUser.id
      };
    }
    this.apiService.get('organizationchart/addtree',params).subscribe(data => {
      this.addSingle('success', 'Successo', 'Organization chart salvato');
    });
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  

  collapsing(args): void {
    if (args.data.hasChildRecords) {
      this.collapseDeepChild(args.data); 
    }
  }
  
  public collapseDeepChild(data): void {
    let child = data.childRecords;
    if(child)
    for (let i = 0; i < child.length; i++) {
      if (child[i].hasChildRecords) {
        this.collapseDeepChild(child[i]);
        this.treegrid.collapseRow(null, child[i]); 
      }
    }
  }


   permessiPerApp(){
    let pathObj={
      roles:[],
      apps:[]
    }
    
    this.getPermessiperData(this.currentNode,pathObj);
    this.currentNodeApps=pathObj;

   }

   getPermessiperData(node,pathObj){
   
    if((node.taskData)&&(node.taskData.roles)){

      node.taskData.roles.forEach((e) => {
     
        let crole=this.rolesList.filter((x)=>x.value ==e)[0];
   
        if(crole &&  crole.childs){
         
          crole.childs.forEach((a)=>{
         

            let af=pathObj.apps.filter((x)=> x.node==a.node);
            if(af.length>0){
          
              if((af[0].access)&&(af[0].access=='ABILITATO')&&(a.access=='DISABILITATO')){
                pathObj.apps.forEach((x,ind)=>{
                  if(x.node==a.node){
                    pathObj.apps[ind].access=a.access;
                  }
                });
              }
            } else {
              pathObj.apps.push(a);
            }
          });
        }
        pathObj.roles.push(e);
      });
    }
   
    if(node.parentItem){
      this.getPermessiperData(node.parentItem,pathObj);
    }
   }

   recordDoubleClick(event){

    this.treegrid.endEdit();

    this.currentNode=event.rowData;
    this.currentNode.index=event.rowIndex;
 
    console.log(this.currentNode.roles);
    if((this.currentNode.roles)&&((this.currentNode.roles.length==1)&&((this.currentNode.roles)[0].value==0))){
      this.currentNode.roles=[];
    }
    if(this.currentNode.type=='USER'){
      this.currentNode.email='';
      this.currentNode.lastLogin='';
      let params={user_id:this.currentNode.code};
      this.apiService.get('organizationchart/getuserpref',params).subscribe((data:any) => {
        if(data.Result){
          this.currentNode.email=data.Result.EMAIL_USER;
          this.currentNode.lastLogin=data.Result.D_ULT_ACCESSO;
          this.currentNode.ruolo_arkiweb=data.Result.ruolo_arkiweb;
          
        }
      });
    }
    if(this.currentNode.type=='USER'){
      this.currentNodeHeader='Ruolo e permessi utente';
    } else {
      this.currentNodeHeader='Permessi nodo corrente';
    }
    this.currentNodeDialogHeader="Modifica "+this.currentNode.name;
    this.permessiPerApp();
    this.nodeAreaLoadSub=false;
    this.nodeRsaLoadSub=false;
    this.confermaElimina2=false;
    this.confermaElimina1=false;
    this.nodeSedeLoadSub=false;
    this.nodeUsersDeptLoadSub=false;
    this.uplevel=false;
    this.showDialogNodo=true;
   }

   getQualifica(q){
    if(q){
      if(this.qualificheList.filter((x)=>x.value ==q).length>0){
        return this.qualificheList.filter((x)=>x.value ==q)[0].label;
      } else {
        return '';
      }
        

    } else {
      return '';
    }
   }

   getRoles(roles){

    if(roles){
  
      let r='';
      roles.forEach((role)=>{
       if(typeof role !== 'object')
        r+= ' '+this.rolesList.filter((x)=>x.value ==role)[0].label;
      });
      return r;
    } else {
      return '';
    }
   }

   saveCurrentNode(){
   
    
      if(this.currentNode.type=='USER' && this.currentNode.isNew && this.newUserSelect=='seleziona'){
        this.currentNode.name=this.autocompleteUsers['itemData']['text'];
        this.currentNode.code=this.autocompleteUsers['itemData']['value'];
      } 
     console.log('this.currentNode.roles',this.currentNode.roles);
      this.currentNode.isNew=false;
      let newNode:any={
        id: this.currentNode.id,
        name:this.currentNode.name,
        code:this.currentNode.code,
        qualifica:this.currentNode.qualifica,
        roles:this.currentNode.roles,
        type:this.currentNode.type,
        childs:this.currentNode.childs,
        updated:true,
        isNew:false
      };
      this.treegrid.updateRow(this.currentNode.index,newNode);
      this.treegrid.endEdit();

      if((this.currentNode.type=='REP')&&(this.currentNode.code)&&(this.nodeRsaLoadSub)){
        let id_struttura=this.currentNode.code;
        this.apiService.get('organizationchart/getusersperdept',{id_reparto:this.currentNode.code,id_struttura:id_struttura}).subscribe(data => {
          data.Result.forEach((r)=>{
            const guidChild = uuidv4();
            let c={
                id:guidChild,
                name:r.USER,
                code:r.ID_USER,
                isManagement:false,
                 roles:[],
                type:'USER',
                childs:[]
              };
              newNode.childs.push(c);
          });
        
            this.cid=newNode.id;
            this.orgList.forEach((r,ind,objOrg)=>{
              this.updateNode(objOrg[ind],newNode);
            });
            this.treegrid.dataSource=this.orgList;
            this.treegrid.refresh();
            this.showDialogNodo=false;
        });
        return;
      }
      // carica reparti e utenti per la struttura
      if((this.currentNode.type=='RSA')&&(this.currentNode.code)&&(this.nodeRsaLoadSub)){
       
        let newNode:any={
          id: uuidv4(),
          name:'Reparti',
          code:'',
          roles:[],
          isManagement:false,
          type:'GENERICO',
          childs:[]
        };
        this.treegrid.addRecord(newNode, this.currentNode.index, 'Child');
        this.orgList=(this.treegrid.dataSource as any);
        
        this.cid=newNode.id;

        this.apiService.get('organizationchart/getstrutturawithdepts',{id_cdc:this.currentNode.code}).subscribe(data => {

          data.Result.forEach((r,ind)=>{
            const guidChild = uuidv4();
            let cdept={
                id:guidChild,
                name:r.desc_reparto,
                code:r.id_reparto,
                isManagement:false,
                roles:[],
                type:'REP',
                childs:[]
            };
          
            let id_struttura=this.currentNode.code;

            this.apiService.get('organizationchart/getusersperdept',{id_reparto:r.id_reparto,id_struttura:id_struttura}).subscribe(datausers => {
              datausers.Result.forEach((us,indusr)=>{
                  const guidChild = uuidv4();
                  let cuser={
                      id:guidChild,
                      name:us.USER,
                      code:us.ID_USER,
                      isManagement:false,
                      roles:[],
                      type:'USER',
                      childs:[]
                    };
                    cdept.childs.push(cuser);
              });
              newNode.childs.push(cdept);
              if(ind==data.Result.length-1){
                this.treegrid.dataSource=this.orgList;
                this.treegrid.refresh();
                this.showDialogNodo=false;
              }
            });
          });
        

        });
        return;
      } 
      
      this.showDialogNodo=false;
  
     
  }
   


  onPermessiChange(event){
    this.permessiPerApp();
  }

  deleteNode(){
    if((!this.confermaElimina1)||(!this.confermaElimina2)){
      return;
    }
    this.orgList.forEach((r,ind,objOrg)=>{
      this.deleteNodeRec(objOrg[ind]);
    });
      
    this.treegrid.dataSource=this.orgList;
    this.treegrid.refresh();
    this.showDialogNodo=false;
  }
 

  deleteNodeRec(node:any){
    if(node.childs){
      node.childs.forEach( (n,i,objN)=>{
        if(n.id==this.cid){
          if(n.type=='USER'){
            this.usersDeleted.push(n);
          }
          node.childs.splice(i,1);
          return;
        }
        this.deleteNodeRec(objN[i]);
      });
    }
  }
  

  newNode(){
    let newNode={
      id: uuidv4(),
      name:'nuovo nodo',
      code:0,
      qualifica:'',
      roles:[],
      type:'',
      childs:[],
      isNew:true
    };
    
    if(this.selectedrecords){
      if(this.selectedrecords[0].type=='REP'){
        
        newNode.type='USER';
        newNode.name='nuovo utente';
        this.currentNodeHeader='Ruolo e permessi utente';
      } else{
        this.currentNodeHeader='Permessi nodo corrente';
      }

      this.currentNode=newNode;
    
      this.treegrid.addRecord(newNode, this.selectedrecords[0].index, 'Child');
      setTimeout(() => {
        this.treegrid.expandByKey(this.selectedrecords[0].id);
      }, 1000);
    
     
    }
  
  }
  
  addNodeRec(node:any,newNode){
    if(node.childs){
      node.childs.forEach( (n,i,objN)=>{
        if(n.id==this.selectedrecords[0].id){
          
          if(!n.childs){
            n.childs=[];
          }
          n.childs.push(newNode);
          this.treegrid.dataSource=this.orgList;
          this.currentNode=newNode;
          return;
        }
        this.addNodeRec(objN[i],newNode);
      });
    }
  }

  rowSelected(args: RowSelectEventArgs) {
   
    this.selectedrecords= (this.treegrid as TreeGridComponent).getSelectedRecords();  // Get the selected records.
    if(this.selectedrecords.length>0){
      this.cid=this.selectedrecords[0].id;
    }
   }

   closeDialog(){
    this.showDialogNodo=false;
    this.treegrid.closeEdit();
   }
   
   nomeIsReadOnly(){
    if((this.filtroAttivo=='')&&(this.currentNode.type=='USER')){  // utenti del gruppo la villa non si puo modificare username 
      return true;
    }
    return false;
   }

}
